import { useSkaldElements } from "@skaldaura/devkit"
import PagesReader from "components/pagesReader/pagesReader"
import { useState } from "react"
import Popup from "reactjs-popup"
import "./manuelOperateur.scss"

export default function ManuelOperateur() {
   const [pages] = useSkaldElements("Manuel opérateur")
   const [isOpen, setOpen] = useState(false)

   const closeModal = () => setOpen(false)
   const openModal = () => setOpen(true)

   return (
      <div id="manuel-operateur">
         {pages.length > 0 && <Popup
            trigger={
               <div id="manuel-trigger">
                  <img src={pages[0].value} />
                  <img src={`${process.env.PUBLIC_URL}/img/picto_black.png`} id="manuel-finger" />
               </div>
            }
            modal
            closeOnDocumentClick
            open={isOpen}
            onClose={closeModal}
            onOpen={openModal}
         >
            {

               <PagesReader pages={pages.map((page) => page.value)} close={closeModal} />
            }
         </Popup>}
      </div>
   )
}
